// get original object field based on case insensitive field

function getOriginalFieldBasedOnCaseInsensitiveField(field, obj) {

    if (typeof obj !== 'object') return "";


    try {
        let fieldStr = String(field);
        fieldStr = fieldStr.toLowerCase();

        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {

                if (fieldStr == key.toLocaleLowerCase()) {

                    return key;
                }
            }
        }

    } catch (error) {

        console.log("Error in GetOriginalObjFieldBasedOnAnyCase.js", error);
        return "";
    }


    return "";
} 

export default getOriginalFieldBasedOnCaseInsensitiveField;